import { VoiceOptions } from "~/modules/voice/voiceOptions";

export const getDefaultVoiceOptions = (): VoiceOptions => ({
    autoAcceptIncomingCalls: true
});
